import { render, staticRenderFns } from "./new_user_gift_edit.vue?vue&type=template&id=6f28923d&scoped=true"
import script from "./new_user_gift_edit.vue?vue&type=script&lang=js"
export * from "./new_user_gift_edit.vue?vue&type=script&lang=js"
import style0 from "./new_user_gift_edit.vue?vue&type=style&index=0&id=6f28923d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f28923d",
  null
  
)

export default component.exports